/* Kattlandet startsida – små interaktioner. Fungerar även i temaeditorn. */
(function(){
  document.documentElement.classList.add('kl-js');
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); var c=e.target.querySelector('[data-count]'); if(c) countUp(c); io.unobserve(e.target); } });
  },{threshold:.12}) : null;

  function countUp(el){
    if(el.dataset.done) return; el.dataset.done='1';
    var end=parseFloat(el.dataset.count)||0, suf=el.dataset.suffix||'', t0=performance.now();
    (function f(t){ var p=Math.min(1,(t-t0)/1400), v=Math.round(end*(1-Math.pow(1-p,3)));
      el.textContent=v.toLocaleString('sv-SE')+suf; if(p<1) requestAnimationFrame(f); })(t0);
  }

  function ship(root){
    root.querySelectorAll('[data-kl-ship]').forEach(function(el){
      var cut=parseInt(el.dataset.cutoff||'11',10);
      function tick(){
        var now=new Date(new Date().toLocaleString('en-US',{timeZone:'Europe/Stockholm'}));
        var d=now.getDay(), h=now.getHours(), m=now.getMinutes();
        if(d>=1&&d<=5&&h<cut){ var left=cut*60-(h*60+m);
          el.innerHTML='<b>Beställ inom '+Math.floor(left/60)+' tim '+(left%60)+' min</b> så skickas din order idag.';
        } else { var names=['söndag','måndag','tisdag','onsdag','torsdag','fredag','lördag'], n=(d+1)%7;
          while(n===0||n===6) n=(n+1)%7;
          el.innerHTML='<b>Beställ nu</b> – din order skickas '+(n===(d+1)%7?'i morgon':'på '+names[n])+'.';
        }
      }
      tick(); if(!el.dataset.t) el.dataset.t=setInterval(tick,30000);
    });
  }

  function tabs(root){
    root.querySelectorAll('[data-kl-tabs]').forEach(function(box){
      var btns=box.querySelectorAll('.tab'), cards=box.querySelectorAll('.card');
      function show(name){
        btns.forEach(function(b){ b.setAttribute('aria-selected', b.dataset.t===name ? 'true':'false'); });
        cards.forEach(function(c){
          var list=(c.dataset.tabs||'').split('|'); var on=list.indexOf(name)>-1;
          c.hidden=!on; c.classList.remove('show'); if(on){ void c.offsetWidth; c.classList.add('show'); }
        });
      }
      btns.forEach(function(b){ b.addEventListener('click', function(){ show(b.dataset.t); }); });
      if(btns.length) show(btns[0].dataset.t);
    });
  }

  function init(root){
    root = root || document;
    root.querySelectorAll('.klh .rise').forEach(function(el){
      if(io) io.observe(el); else el.classList.add('in');
    });
    root.querySelectorAll('.klh [data-count]').forEach(function(el){ if(!io) countUp(el); });
    ship(root); tabs(root);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){ init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
